import axios from "axios";
import { getBaseUrl } from "./lib/pageUrl";
import { onEachAssetImage, onEachComponent } from "./lib/componentHelpers";

const uploadUrl = getBaseUrl() + "/";
export default {
  assets: [],
  noAssets: "",
  stylePrefix: "am-",
  upload: uploadUrl,
  multiUpload: true,
  autoAdd: true,
  showUrlInput: false,
  embedAsBase64: false,
  customFetch: async (uploadUrl: string, options: { body: FormData }): Promise<{ data: string[] }> => {
    const data = await Promise.all(
      Array.from((options.body as FormData).values()).reduce<Promise<string>[]>((out, file) => {
        if (typeof file === "string") return out;
        const name = file.name.replace(" ", "_");
        const fileUrl = `${uploadUrl}${name}`;
        out.push(axios.put(fileUrl, file).then(() => name));
        return out;
      }, [])
    );
    return { data };
  },
};

const absolute = url => new URL(url, uploadUrl).toString();

export function plugin(editor) {
  const { AssetManager, StyleManager } = editor;

  const origGetPreview = AssetManager.getType("image").view.prototype.getPreview;
  AssetManager.addType("image", {
    view: AssetManager.getType("image").view.extend({
      getPreview() {
        return origGetPreview.call(this).replace(this.model.get("src"), absolute(this.model.get("src")));
      },
    }),
  });

  const origSetPreview = StyleManager.getType("file").view.prototype.setPreview;
  StyleManager.addType("file", {
    view: StyleManager.getType("file").view.extend({
      setPreview(value) {
        value = value ? value.replace(/(?:url\()?["']?([^"']+)["']?(:?\))?/, "$1") : value;
        value = value ? `url("${absolute(value)}")` : value;
        return origSetPreview.call(this, value);
      },
    }),
  });

  editor.on("storage:loaded", () => {
    const doc = editor.Canvas.getDocument() as HTMLDocument;
    const pageBase = doc.querySelector("base")?.getAttribute("href") ?? "";
    const baseEl = (doc.head.querySelector("base[data-do-not-store=true]") ||
      doc.head.insertAdjacentElement("afterbegin", doc.createElement("base"))) as HTMLBaseElement;
    baseEl.setAttribute("data-do-not-store", "true");
    baseEl.href = absolute(pageBase);
  });

  editor.on("storage:end:load", () => {
    onEachComponent(editor.getWrapper(), component =>
      onEachAssetImage(component, url => AssetManager.get(url) || AssetManager.add(url))
    );
  });
}
